import {inject, Injectable, signal} from '@angular/core';
import {AuthService} from "./auth/auth.service";
import {ApartmentService} from "./apartment.service";
import {environment} from "../../../environments/environment";
import {NotificationService} from "./notification/notification.service";
import {NativeAppService} from "./native-app/native-app.service";
import {UserService} from "./user.service";
import {PaymentService} from "./payment/payment.service";
import {PushNotificationService} from "./push-notification.service";

@Injectable({
  providedIn: 'root'
})
export class DataUpdateService {
  private lastUpdateDate: Date | null = null;

  public readonly initialDataRetrieved = signal(false);

  private readonly authService = inject(AuthService);
  private readonly apartmentService = inject(ApartmentService);
  private readonly notificationService = inject(NotificationService);
  private readonly nativeService = inject(NativeAppService);
  private readonly userService = inject(UserService);
  private readonly paymentService = inject(PaymentService);
  private readonly pushNotificationService = inject(PushNotificationService);

  public async updateData(options?: {force: boolean}) {
    if (options?.force) {
      this.lastUpdateDate = null;
    }

    if (this.lastUpdateDate !== null && (new Date().getTime() - this.lastUpdateDate.getTime() < environment.dataRefreshTime)) {
      if (typeof window !== 'undefined' && window.location.pathname.includes('account/subscription')) {
        await this.authService.retrieveData();
      }

      void this.pushNotificationService.refreshDevicePushPermissionStatus().catch(
          e => console.error("Failed to refresh push permissions", e));

      return;
    }


    try {
      console.log("Refreshing data...");
      await this.nativeService.retrieveData();
      await this.authService.retrieveData();
      await this.apartmentService.retrieveData();
      void this.notificationService.retrieveData();
      void this.paymentService.checkTrialAvailability();
      void this.pushNotificationService.refreshDevicePushPermissionStatus();
      this.lastUpdateDate = new Date();
      this.initialDataRetrieved.set(true);

      this.userService.markSeen();
      console.log("Data refreshed successfully.");

    } catch (error) {
      console.warn('DataUpdateService failed to refresh data during server render', error);
    }
  }
}
